import {default as classNames} from "classnames";
import {Children, cloneElement, isValidElement, ReactElement} from "react";

import {InputElementProps} from "@/components/inputGroup/subComponents/inputElement/InputElement.types.ts";

import styles from "./InputElement.module.scss";

// This is an element that can appear at the start or end of an input. Usually an icon.
// It will float above the input. but also push the input start offset from the element
export const InputElement = ({
  placement = "start",
  offSet,
  disablePointerEvents = true,
  disabled,
  "aria-invalid": ariaInvalid,
  children,
}: InputElementProps) => {
  if (isValidElement(children)) {
    children = Children.map(
      children as ReactElement<{
        "aria-disabled"?: boolean;
        "aria-invalid"?: boolean | "false" | "true" | "grammar" | "spelling" | undefined;
      }>,
      (child) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            "aria-disabled": disabled,
            "aria-invalid": ariaInvalid,
          });
        }
        return child;
      }
    );
  }

  return (
    <div
      className={classNames(
        styles[placement],
        {
          [styles.disabled]: disabled,
        },
        {
          [styles.disablePointerEvents]: disablePointerEvents || disabled,
        },
        styles.inputElement,
        "input-element" // used for group targeting
      )}
      style={{
        ...(placement === "start" ? {left: offSet} : {}),
        ...(placement === "end" ? {right: offSet} : {}),
      }}
    >
      {children}
    </div>
  );
};
